import type { FilterHtmlByDataAttributesOptions } from './filter-html-by-data-attributes.types';

/**
 * Filter configuration for creating cards from Ask Klue answers
 * Removes interactive/collapsible elements that don't belong in static card content
 */
export const ASK_KLUE_CARD_CREATION_FILTER: FilterHtmlByDataAttributesOptions =
  {
    rules: [
      {
        attribute: 'collapsible',
        value: 'true',
      },
      {
        attribute: 'list-with-clickable-items',
        value: 'true',
      },
    ],
    preserveStructure: true,
  };
